export default __webpack_public_path__ + "static/media/group-2@3x.e5bd63d7.png";